import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import {
  addEmployeeLeaveRequest,
  NewEmployeeLeaveRequest
} from 'RestAPIs/employees/leave-requests';
import { useMutation, useQueryClient } from 'react-query';

const useAddLeaveRequest = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (newLeaveRequest: NewEmployeeLeaveRequest) =>
      addEmployeeLeaveRequest(newLeaveRequest),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('employeeLeaveRequests');
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddLeaveRequest;
